export const COMPLETED = 'COMPLETED';
export const DEFERRED = 'DEFERRED';
export const IN_PROGRESS = 'IN_PROGRESS';
export const NOT_STARTED = 'NOT_STARTED';
export const WAITING = 'WAITING';